module.exports = __webpack_public_path__ + "static/media/cyllene.889c5fec.png";